import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MultiSelectFilter from '../../../Common/Inputs/MultiSelectFilter';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { getUsersList } from '../../../../actions/Users/UserAction';
import { setPillsBugs, setPillState } from '../../../../actions/Users/UserAction';
import { closeSearchFilterPanel } from '../../../../actions/Users/UserAction';
import { flatten, without } from 'ramda';
import Constants from '../../../../Constants';

const SEARCH_BAR_THRESHOLD = 7;

class PillBugsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      optionsList: null,
      toggle: false,
      clearSearch: false,
      searchTerm: '',
    };
    this.refToClearAll = React.createRef();
  }

  handleInputChange = (value) => {
    this.setState({
      optionsList: this.getAllAvailableOptions().filter((el) => el.name.toLowerCase().includes(value.toLowerCase())),
      searchTerm: value,
      clearSearch: false,
    });
  };

  removePill = (e) => {
    e.stopPropagation();
    this.setState({
      clearSearch: true,
      toggle: false,
    });
    this.props.setPillState(this.props.name);
    this.props.onRemove();
  };

  clearSelectedOptions = (e) => {
    e.stopPropagation();
    this.setState({
      clearSearch: true,
    });
    this.props.onRemove();
  };

  onToggleDropdownMenu = (e) => {
    e.stopPropagation();
    this.setState({
      toggle: !this.state.toggle,
    });
    this.props.closeSearchFilterPanel();
  };

  closeDropdown = () => {
    this.setState({
      toggle: false,
    });
  };

  onKeyDown = (e) => {
    e.key === 'Escape' ? this.closeDropdown(e) : void 0;
  };

  onKeyDownClearLink = (e) => {
    e.key === 'Enter' ? this.clearSelectedOptions(e) : void 0;
  };

  onLastItemBlur = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.refToClearAll.current.focus();
    return false;
  };

  onPillOptionsChanged = (inputFields, idObj) => {
    const currentSelectedIds = this.props.filtersSelected[this.props.userSearchFilterKey];
    this.props.getUsersList({
      pageSize: Constants.userListDefaultPageSize,
      pageNumber: 0,
      terms: {
        [this.props.userSearchFilterKey]: currentSelectedIds.includes(idObj.id)
          ? without([idObj.id], currentSelectedIds)
          : [...currentSelectedIds, idObj.id],
      },
    });
  };

  renderSelectedItems() {
    const names = this.getUserListAppliedFilterItems();
    return (names || []).length > 0 ? (
      flatten(
        names.map((item) => [
          <span key={`pill_text_of_${item.name}`}>{new String(item.name || item)}</span>,
          <span key={`pill_text_of_${item.name}_comma`}>,</span>,
        ]),
      ).slice(0, -1)
    ) : (
      <span>Any</span>
    );
  }

  getUserListAppliedFilterItems() {
    const usersList = this.props.usersList;
    switch (this.props.userSearchFilterKey) {
      case 'casId': {
        return usersList.userSearchFilters.casId;
      }
      case 'clientId': {
        return usersList.userSearchFilters.clientId;
      }
      case 'userRoleId': {
        return usersList.userSearchFilters.userRoleId;
      }
      case 'institutionId': {
        return usersList.userSearchFilters.institutionId;
      }
      case 'status': {
        return usersList.userSearchFilters.status;
      }
      case 'internalUser': {
        return usersList.userSearchFilters.internalUser ? [usersList.userSearchFilters.internalUser] : [];
      }
    }
  }

  getAllAvailableOptions() {
    switch (this.props.userSearchFilterKey) {
      case 'casId': {
        return this.props.filterOptionsFor.cas;
      }
      case 'clientId': {
        return this.props.filterOptionsFor.orgs;
      }
      case 'userRoleId': {
        return this.props.filterOptionsFor.userRoles;
      }
      case 'institutionId': {
        return this.props.filterOptionsFor.institutions;
      }
      case 'status': {
        return this.props.filterOptionsFor.statuses;
      }
      case 'internalUser': {
        return this.props.filterOptionsFor.internalUser;
      }
    }
  }

  showSearchInput() {
    return this.getAllAvailableOptions().length > SEARCH_BAR_THRESHOLD;
  }

  render() {
    const dropDown = this.state.toggle;

    const dataHolder = this.state.clearSearch
      ? this.getAllAvailableOptions()
      : this.state.optionsList || this.getAllAvailableOptions();
    const searchQuery = this.state.clearSearch ? '' : this.state.searchTerm;

    return (
      <div className="pillbugs-contents" onKeyDown={(e) => this.onKeyDown(e)}>
        <button
          aria-label={`close selected ${this.props.name} filter`}
          className="removePill"
          data-testid="remove-pill"
          onClick={(e) => this.removePill(e)}>
          <i className="far fa-times-circle" />
        </button>
        <Dropdown isOpen={dropDown} className="filter-pillbugs-dropdown" toggle={(e) => this.onToggleDropdownMenu(e)}>
          <DropdownToggle className="pillBugs-button fontSm-12">
            <span>{this.props.name}</span>
            <span className="pXSm-5">{'>'}</span>
            <span className="limitNames">{this.renderSelectedItems()}</span>
            <span>
              <i className="fa fa-caret-down mLeft-5 pTop-2" />
            </span>
          </DropdownToggle>
          <DropdownMenu className={'dropDown-action widthAdd pillbugs-dropdown ' + this.props.name}>
            <div className="active-filters">
              <button
                autoFocus
                ref={this.refToClearAll}
                tabIndex={'0'}
                className="ref-blue-text inline-block"
                onClick={(e) => this.clearSelectedOptions(e)}
                onKeyDown={(e) => this.onKeyDownClearLink(e)}>
                Clear All
              </button>
            </div>
            <MultiSelectFilter
              isEmbedMenu
              searchBar={this.showSearchInput()}
              onInputChange={this.handleInputChange}
              clientIdsSelectedEvent={this.onPillOptionsChanged}
              placeholder="Search"
              clientIdsSelected={this.props.filtersSelected[this.props.userSearchFilterKey]}
              name={this.props.name}
              dataObj={dataHolder}
              originalData={this.getAllAvailableOptions()}
              value={searchQuery}
              noResult={true}
              focusToFirstPosition={(e) => this.onLastItemBlur(e)}
            />
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    usersList: state.Users.usersList,
    pillsEnabled: state.Users.usersPills,
    filtersSelected: state.Users.usersList.terms,
    filterOptionsFor: state.Users.filterOptions,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getUsersList,
      setPillsBugs,
      setPillState,
      closeSearchFilterPanel,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(PillBugsContainer);
